import { Component, effect, input, signal, WritableSignal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { City, Province, Region } from 'src/app/interfaces/location';
import { ValidationErrorComponent } from "../../../../../pages/public/register/common/validation-error/validation-error.component";

@Component({
  selector: 'user-location',
  imports: [
    ReactiveFormsModule,
    ValidationErrorComponent
],
  templateUrl: './location.component.html',
  styleUrl: './location.component.scss'
})
export class LocationComponent {
  form = input.required<FormGroup>();
  editing = input.required<boolean>();
  //DATA
  data_regions = input<Region[]>([]);
  data_provinces: Province[]=[];
  data_city: City[]=[];
  //UI
  loading: WritableSignal<boolean> = signal(false)

  constructor() {
    effect(() => { this.editing() ? this.form().enable() : this.form().disable(); });

    effect(() => {
      const regionId = this.form()?.get('region_id');
      const provinceId = this.form()?.get('province_id');
      regionId?.valueChanges.subscribe(value => this.onRegionSelected(value));
      provinceId?.valueChanges.subscribe(value => this.onProvinceSelected(value));
      //PRELOAD
      this.findProvinces(regionId?.value ?? '');
      this.findCities(provinceId?.value ?? '');
    });
  }

  onRegionSelected(region_uuid: string) {
    this.findProvinces(region_uuid)
    this.form().get('province_id')?.setValue('');
    this.form().get('city_id')?.setValue('');
  }

  onProvinceSelected(province_uuid: string) {
    this.findCities(province_uuid)
    this.form().get('city_id')?.setValue('');
  }

  findProvinces(region_uuid: string){
    this.data_provinces = this.data_regions().find(el=> el.uuid == region_uuid)?.provinces ?? [];
  }

  findCities(province_uuid: string){
    this.data_city = this.data_provinces.find(el=> el.uuid == province_uuid)?.cities ?? [];
  }

}
